document.addEventListener('DOMContentLoaded', ()=> {
    const lines = document.querySelectorAll('.spcfx-faq .line');
    lines.forEach(line => {
        line.addEventListener('click', () => {
            const content = line;
            if (content.classList.contains('active')) {
                content.classList.remove('active');
            } else {
                content.classList.add('active');
            }
        });
    });
});
